/*=========================================================================================
  File Name: moduleProjectMutations.js
  Description: Project Module Mutations
==========================================================================================*/

export default {
	SET_PROJECTS_SEARCH_QUERY(state, query) {
		state.projectsSearchQuery = query;
	},
	UPDATE_PROJECTS_FILTER(state, filter) {
		state.projectsFilter = filter;
	},

	// API
	SET_PROJECTS(state, projects) {
		state.projects = projects;
	},

	ADD_PROJECT(state, project) {
		state.projects.unshift(project);
	},

	UPDATE_PROJECT(state, project) {
		const projectIndex = state.projects.findIndex(t => t.id === project.id);
		Object.assign(state.projects[projectIndex], project);
	},

	DELETE_PROJECT(state, projectId) {
		const projectIndex = state.projects.findIndex(t => t.id == projectId);
		state.projects.splice(projectIndex, 1);
	},
	SET_TOTAL_PROJECTS(state, total) {
		state.total = total;
	},
	ADD_PROJECT_DEBT(state, debt) {
		state.debts.push(debt);
	},
	SET_PROJECT_DEBTS(state, debts) {
		state.debts = debts;
	},
	SET_TOTAL_PROJECT_DEBTS(state, total) {
		state.debtsTotal = total;
	},
	SET_SHOW_PRODUCTS(state, products) {
		state.showProducts = products;
	},
	INCREASE_TOTAL_DEBTS(state) {
		state.debtsTotal = state.debtsTotal + 1;
	},
	SET_PROJECT_DEBTS_REPORT_EXCEL(state, report) {
		state.debtsReportExcel = report;
	},
	UPDATE_PROJECT_ACCCESSABLE_FIELDS(state, fields) {
		state.acccessableFields = fields;
	},
	SET_PIPELINES(state, pipelines) {
		state.pipelines = pipelines;
	},
	ADD_PIPELINE(state, pipeline) {
		state.pipelines = [...state.pipelines, pipeline];
	},
	UPDATE_PIPELINE(state, pipeline) {
		const idx = state.pipelines.findIndex(t => t.id === pipeline.id);
		Object.assign(state.pipelines[idx], pipeline);
	},
	DELETE_PIPELINE(state, id) {
		const idx = state.pipelines.findIndex(t => t.id == id);
		state.pipelines.splice(idx, 1);
	},
	SORT_PIPELINE() {},
	SET_TOTAL_SHOW_PRODUCTS(state, total) {
		state.totalShowProducts = total;
	},
	ADD_PRODUCT(state, product) {
		state.showProducts = [...state.showProducts, product];
		state.totalShowProducts = state.totalShowProducts + 1;
	},
	UPDATE_PRODUCT(state, product) {
		const idx = state.showProducts.findIndex(t => t.id === product.id);
		Object.assign(state.showProducts[idx], product);
	},
	DELETE_PRODUCT(state, id) {
		const idx = state.showProducts.findIndex(t => t.id == id);
		state.showProducts.splice(idx, 1);
		state.totalShowProducts = state.totalShowProducts - 1;
	}
};
